import AlertPopUpView from './AlertPopUp.view';
export * from './AlertPopUp.view';

export const AlertPopUp = (props) => AlertPopUpView(props);

export default AlertPopUp;

